import { formatPhoneNumber } from '@/utils/helpers';
import type { TPhoneState } from '@stores/ui/ui.types';

export const formatSelfPhone = (ddd: string, phone: string): string => {
	const splitAt = phone.length > 8 ? 5 : 4;
	return `(${ddd}) ${phone.substring(0, splitAt)}-${phone.substring(splitAt)}`;
};

export const resolvePhone = (storeChatPhone: TPhoneState, isLoading: boolean): string | null => {
	if (isLoading) return null;
	if (!storeChatPhone.fetched && !storeChatPhone.error) return null;

	const { source } = storeChatPhone;

	if (typeof source === 'string' && source.length > 0) {
		return formatPhoneNumber(source);
	}

	if (
		typeof source === 'object' &&
		source?.ResidentialPhone &&
		source.ShowPhone === '1'
	) {
		return formatPhoneNumber(source.ResidentialPhone.toString());
	}

	return 'Telefone não compartilhado';
};
